import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { checklistSectionCreateModelToOutDto } from 'shared/domain/checklistSection/mapping/toDto';
import { ChecklistSectionCreateModel } from 'shared/domain/checklistSection/types/model';
import { AddChecklistSectionUseCase } from 'shared/domain/checklistSection/types/useCases';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { ChecklistSectionHttpCreateRequestModel } from '../httpQueue/checklistSection/types';

export class ChecklistSectionSaver implements AddChecklistSectionUseCase {
  constructor(
    private addRequest: (
      request: ChecklistSectionHttpCreateRequestModel
    ) => Promise<number>
  ) {}

  async execute(
    createModel: ChecklistSectionCreateModel,
    uniqueId: string
  ): Promise<void> {
    debugLog('AddChecklistSectionUseCase', createModel);

    const checklistSectionCreateOutDto =
      checklistSectionCreateModelToOutDto(createModel);
    const url = `/project/${createModel.projectId}/inspectionTemplate/${createModel.inspectionTemplateId}/section`;

    const request: ChecklistSectionHttpCreateRequestModel = {
      createdAt: Date.now(),
      method: 'POST',
      data: {
        checklistSectionCreateOutDto,
        projectId: createModel.projectId,
        inspectionTemplateId: createModel.inspectionTemplateId,
        uniqueId: uniqueId,
      },
      url,
      entityType: HttpRequestModelType.checklistSection,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const checklistSectionSaver = new ChecklistSectionSaver(addRequest);
